module.exports = __webpack_public_path__ + "static/media/ad0.ee3d2284.png";